import { api } from "@api/api";
import { BookAuthor } from "@modules/bookAuthors/types";
import { BookAuthorFormValues } from "@modules/bookAuthors/validations";

export async function createBookAuthorService(data: BookAuthorFormValues): Promise<BookAuthor> {
  const { data: bookAuthor } = await api.post<BookAuthor>("v1/book_contributor_admin/", data);

  return bookAuthor;
}
